module.exports = __webpack_public_path__ + "img/Multi_Assign.a01280cf.svg";